<div class="progress-bar">
  <div #progresbar id="bar" [style.width]="percentage" [style.height]="height"></div>
</div>